import { faSearch } from "@fortawesome/pro-regular-svg-icons/faSearch";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconSearch: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faSearch} />;
};
